import { diffYears } from '@formkit/tempo';
import { parseDt } from './';

export function calcAge(birthday: string): number {
    const dt = parseDt(birthday);
    return diffYears(new Date(), dt);
}
